function loadSAstars() {
  const products = document.querySelectorAll(".boost-sd__product-item");
  const priceBlocks = document.querySelectorAll(".boost-sd__product-price");

  if (products.length > 0) {
    for (let i = 0; i < priceBlocks.length; i++) {
      const product = products[i];
      const priceEl = priceBlocks[i];
      const prodId = product.getAttribute("data-product-id");

      if (!prodId) continue;
      // Avoid inserting if already present
      if (product.querySelector(".star_container")) continue;

      // Inject star container above price
      priceEl.insertAdjacentHTML(
        "beforebegin",
        `<div class="star_container ${prodId}"></div>`
      );
    }

    // Load SA stars after DOM is updated
    setTimeout(() => {
      if (typeof reloadShopperApprovedStars === "function") {
        reloadShopperApprovedStars();
      }
    }, 3000);
  }
}

window.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const categoryGrid = document.querySelector(".boost-sd__product-list");

    if (categoryGrid) {
      loadSAstars();

      // Re-run on pagination
      document
        .querySelectorAll(".boost-sd__pagination button")
        .forEach((btn) => {
          btn.addEventListener("click", () => {
            setTimeout(() => {
              loadSAstars();
            }, 3000);
          });
        });
    }
  }, 3000);
});

function saLoadScript(src) {
  var js = window.document.createElement("script");
  js.src = src;
  js.type = "text/javascript";
  document.getElementsByTagName("head")[0].appendChild(js);
}
saLoadScript("https://www.shopperapproved.com/widgets/group2.0/26849.js");
